import Image from "next/image";
import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import BlogData from "@/data/blog/blog.json";
import { image_url } from "@/helper/Utilities";
import { blogPostSlug } from "@/helper/SpecialHelpers";
import { ROUTE } from "@/route/app_routes.js";


const BlogWidget = ({ extra_class }) => {

    const { t } = useTranslation("blog");
    const [featured, ...rest] = BlogData.blogList;
    const sideItems = rest.slice(0, 2);
    const featuredTitle = t(`posts.${featured.id}.title`, featured.title);

    return (

        <>
            <div className="row g-5">

                <div className={"col-lg-6 col-md-12 col-sm-12 col-12" + extra_class}>
                    <div className="rbt-card variation-02 height-330 rbt-hover">
                        <div className="rbt-card-img">
                            <Link href={ROUTE.blog_details + blogPostSlug(featured)}>
                                <Image src={image_url(featured.img)} width={580} height={300} priority alt={featuredTitle} />
                            </Link>
                        </div>

                        <div className="rbt-card-body">
                            <h3 className="rbt-card-title">
                                <Link href={ROUTE.blog_details + blogPostSlug(featured)}>{featuredTitle}</Link>
                            </h3>
                            <p className="rbt-card-text">{t(`posts.${featured.id}.desc`, featured.desc)}</p>
                            <div className="rbt-card-bottom">
                                <Link className="transparent-button" href={ROUTE.blog_details + blogPostSlug(featured)}>{t("list.readArticle", "Read Article")}
                                    <i><svg width="17" height="12" xmlns="http://www.w3.org/2000/svg"><g stroke="#27374D" fill="none" fillRule="evenodd"><path d="M10.614 0l5.629 5.629-5.63 5.629" /><path strokeLinecap="square" d="M.663 5.572h14.594" /></g></svg></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"col-lg-6 col-md-12 col-sm-12 col-12" + extra_class}>
                    {sideItems.map((post, index) => {
                        const title = t(`posts.${post.id}.title`, post.title);
                        return (
                        <div
                            className={`rbt-card card-list variation-02 rbt-hover${index > 0 ? " mt--30" : ""}`}
                            key={post.id}
                        >
                            <div className="rbt-card-img">
                                <Link href={ROUTE.blog_details + blogPostSlug(post)}>
                                    <LazyImage src={image_url(post.img)} width={580} height={300} alt={title} />
                                </Link>
                            </div>

                            <div className="rbt-card-body">
                                <h3 className="rbt-card-title"> <Link href={ROUTE.blog_details + blogPostSlug(post)}>{title}</Link> </h3>
                                <div className="rbt-card-bottom">
                                    <Link className="transparent-button" href={ROUTE.blog_details + blogPostSlug(post)}> {t("list.readArticle", "Read Article")}
                                        <i><svg width="17" height="12" xmlns="http://www.w3.org/2000/svg" > <g stroke="#27374D" fill="none" fillRule="evenodd"> <path d="M10.614 0l5.629 5.629-5.63 5.629" /> <path strokeLinecap="square" d="M.663 5.572h14.594" /></g></svg></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        );
                    })}
                </div>

            </div>

        </>

    );

};

export default BlogWidget;
